export const pt = {
    map: "ver no mapa"
}

export const en = {
    map: "see at maps"
}